import React from "react";
import PropTypes from "prop-types";

const BlockquoteComponent = ({ value }) => {
  const { text, style = "default" } = value || {};

  if (!text) {
    return null;
  }

  return (
    <blockquote className={`sanity-blockquote sanity-blockquote-${style}`}>
      <p>{text}</p>
    </blockquote>
  );
};

BlockquoteComponent.propTypes = {
  value: PropTypes.shape({
    text: PropTypes.string,
    style: PropTypes.string,
  }),
};

export default BlockquoteComponent;
